import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { Button } from "semantic-ui-react"
import ImageWithFallback from "components/ImageWithFallback"


const Fullscreen = ({ image, change, images, product }) => {

	const [imgs, setImages] = React.useState(null)

	React.useEffect(() => {
		if (image && images) {
			window.scrollTo && window.scrollTo(0, 0)
			document.body.classList.add("no-scroll")
			const imgs = _.map(images, ({ img_src_large, img_src_small }, key) => {
				return (
					<div className="pa2 mw4">
						<ImageWithFallback
							key={key}
							onClick={() => {
								change(img_src_large)
							}}
							className="img-thumbnail cursor-pointer"
							src={img_src_small} />
						<a download={`${product.article_nr}-${product.title}.jpg`} href={img_src_large} className="db ttu pt2 tc black-60 f7">
							<Button size="tiny" primary>Download</Button>
						</a>
					</div>
				)
			})
			setImages(imgs)
		}
		return () => {
			document.body.classList.remove("no-scroll")
		}
	}, [image, change, images])

	if (!image) return null

	return (
		<div className="fullscreen">
			<div className="ui pull-right"
				style={{ position: "relative" }}>
				<Button icon="close"
					basic
					onClick={() => {
						change(false)
					}} />
			</div>

			<div className="center-child "
				onClick={() => {
					change(false)
				}}>
				<div className="zoom-out img-container">
					<img src={image} alt="" />
				</div>
			</div>

			<div className="ui ui-bottom pull-right ">
				<div className="flex flex-row items-center">
					{imgs}
				</div>
			</div>
		</div>
	)
}
Fullscreen.propTypes = {
	children: PropTypes.object, change: PropTypes.func, images: PropTypes.array
}


export default Fullscreen


// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductFullscreen.js